<template>
  <div class="teacher-card">
    <router-link class="teacher-link" :to="{name: 'LecturerDetail', params: {id: item.id}}">
      <div class="teacher-main">
        <div class="teacher-avator lazy-load"><img :src="item.avatar"></div>
        <div class="teacher-info">
          <div class="name">{{item.stagename}}</div>
          <div class="title-box">
            <div class="title">{{item.title1}}</div>
            <div class="title">{{item.title2}}</div>
          </div>
        </div>
      </div>
      <icon icon-class="arrow-right" class="link-arrow"></icon>
    </router-link>
  </div>
</template>

<style lang="less" scoped>
  .teacher-card{
    width: 100%;
    overflow: hidden;
    margin-bottom: 12px;
    border-radius: 8px;
    box-shadow: 0 6px 20px 0 rgba(0,0,0,.1);
    .teacher-link{
      position: relative;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 12px 16px;
      .teacher-main{
        display: flex;
        justify-content: flex-start;
        align-items: center;
        .teacher-avator{
          width: 64px;
          height: 64px;
          border-radius: 50%;
          overflow: hidden;
          display: flex;
          justify-content: center;
          align-items: center;
          img{
            width: 100%;
            height: 100%;
          }
        }
        .teacher-info{
          box-sizing: border-box;
          padding-left: 12px;
          .name{
            font-size: 14px;
            line-height: 14px;
            color: #333;
            font-weight: bold;
          }
          .title-box{
            margin-top: 3px;
            font-size: 12px;
            line-height: 18px;
            color: #999;
            .title{
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
            }
          }
        }
      }
      .link-arrow{
        font-size: 14px;
        color: #CACACA;
      }
    }
  }
</style>

<script>
  export default {
    props: {
      item: Object,
    },
    data() {
      return {}
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Common/lecturerCard.vue